import { Component, EventEmitter, Output } from "@angular/core";
import { ManagementItem, ManagementList } from "@helper/abstraction/management";
import { Store } from "@ngrx/store";

import { GridComponent } from "@shared/grid/grid.component";

@Component({
    selector: "app-user-list",
    templateUrl: "./user-list.component.html",
    styleUrls: ["./user-list.component.scss"]
})
export class UserListComponent<T> extends GridComponent<any> {
    @Output() public selectedUsers: EventEmitter<ManagementList> = new EventEmitter<ManagementList>();
    public selectedItems?: ManagementList = [];

    constructor(
        store: Store<any>,
    ) {
        super(store);
    }

    public checkedItem(user: ManagementItem): boolean {
		if (this.selectedItems) {
			return this.selectedItems.some(selectItem => JSON.stringify(selectItem) === JSON.stringify(user));
		}
		return false;
	}

    public selectedItem(user: ManagementItem): void {
		if (!this.selectedItems?.find(selectedItem => JSON.stringify(selectedItem) === JSON.stringify(user))) {
			this.selectedItems = Object.assign([], this.selectedItems);
			this.selectedItems?.push(user);
			this.selectItems.emit(this.selectedItems);
			return;
		}

		if (this.selectedItems?.length) {
			const newSelectedDocuments = this.selectedItems?.filter((selectedDocument): boolean => JSON.stringify(selectedDocument) !== JSON.stringify(user));
			this.selectedItems = newSelectedDocuments;
			this.selectItems.emit(newSelectedDocuments);
			return;
		}

		this.selectedItems = [];
		this.selectItems.emit([]);
	}
}
